import React from 'react'
import { Dropdown } from 'react-bootstrap'
import styles from './AllProjectsActions.module.css'

const AllProjectsActions = ({ hideSpacesProjects, onToggleHideSpacesProjects }) => {
  const handleToggle = (e) => {
    e.stopPropagation()
    onToggleHideSpacesProjects(!hideSpacesProjects)
  }

  return (
    <Dropdown className={styles.allProjectsActions} onClick={(e) => e.stopPropagation()}>
      <Dropdown.Toggle variant="link" className={styles.gearButton} id="all-projects-actions">
        <img src="/assets/icons/setting-black.svg" alt="All projects options" />
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item onClick={handleToggle} className={styles.dropdownItem}>
          <input
            type="checkbox"
            checked={hideSpacesProjects}
            onChange={handleToggle}
            className={styles.checkbox}
            onClick={(e) => e.stopPropagation()}
          />
          <span>Hide projects in spaces</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default AllProjectsActions
